// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.neftipedia",
    name: "NeftiWallet",
    homepage: "https://neftipedia.com/",
    image_id: "1f812dec-be3d-446c-52f7-a79eb0dd5400",
    app: {
        browser: null,
        ios: null,
        android: "https://play.google.com/store/apps/details?id=com.NEFTiPEDiA.mp",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "nefti://nefti.id/asset/",
        universal: "https://nefti.id/asset/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map